import React, { useContext } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import tw from "twin.macro";

const Wrapper = tw.div`flex flex-col gap-4 relative py-8 [*]:mb-0 bg-dark px-12 my-16 shadow-xl`;
const Title = tw.p`text-4xl font-mazuis relative italic leading-none! text-primary font-bold`;
const List = tw.ol`list-decimal list-outside! ml-0! pl-0! pr-6 text-white`;
const Item = tw.li`[a]:(text-white! font-normal) mb-2!`;

const TableOfContents = ({ table, ...rest }) => {
  return (
    <Wrapper {...rest}>
      <Title>Table of Contents</Title>
      <List>
        {table.map(({ id, title }, i) => (
          <Item key={i}>
            <AnchorLink href={"#" + id} offset="150">
              {title}
            </AnchorLink>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
};

export default TableOfContents;
